export const formatCurrency = (amount, currency = "GBP", locale = "en-GB") => {
  if (isNaN(amount)) return "£0.00";

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};
